var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-app',{attrs:{"md-mode":"fixed"}},[_c('md-app-content',[_vm._t("joint-content")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }